import { Route, Routes, useNavigate } from "react-router-dom";
import Home from "../pages/DefaultPage";
import RescheduleScript from "../pages/second-line/RescheduleScript";
import SuccessScript from "../pages/second-line/SuccessScript";
import ReminderScript from "../pages/second-line/ReminderScript";
import AccessibilityIntervalScript from "../pages/second-line/AccessibilityIntervalScript";
import NewServiceScript from "../pages/second-line/NewServiceScript";
import { ISecondLineRoutes } from "../App.interface";
import { useEffect } from "react";

const SecondLineRoutes = ({ route }: { route: ISecondLineRoutes }) => {
  const navigate = useNavigate();

  useEffect(() => {
    switch (route) {
      case ISecondLineRoutes.reschedule:
        navigate("/reschedule");
        break;
      case ISecondLineRoutes.success:
        navigate("/success");
        break;
      case ISecondLineRoutes.remider:
        navigate("/reminder");
        break;
      case ISecondLineRoutes.accessibilityInterval:
        navigate("/accessability-intervals");
        break;
      case ISecondLineRoutes.newService:
        navigate("/service");
        break;
      default:
        navigate("/");
        break;
    }
  }, [route, navigate]);

  return (
    <Routes>
      <Route path="/" element={<Home></Home>}></Route>
      <Route
        path="/reschedule"
        element={<RescheduleScript></RescheduleScript>}
      ></Route>
      <Route path="/success" element={<SuccessScript></SuccessScript>}></Route>
      <Route
        path="/reminder"
        element={<ReminderScript></ReminderScript>}
      ></Route>
      <Route
        path="/accessability-intervals"
        element={<AccessibilityIntervalScript></AccessibilityIntervalScript>}
      ></Route>
      <Route
        path="/service"
        element={<NewServiceScript></NewServiceScript>}
      ></Route>
    </Routes>
  );
};

export default SecondLineRoutes;
